module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/Coins-60c6c1f722e1821662dde01d5421c07f.png";